module.exports = __webpack_public_path__ + "img/left.11524106.png";